'use client';

import dynamic from 'next/dynamic';

const AssistantPanelLoader = dynamic(
  () => import('./AssistantPanelLoader'),
  { ssr: false }
);

export default function AssistantPanelClient() {
  return <AssistantPanelLoader />;
}
